// extracted by mini-css-extract-plugin
export default {"container":"unauthorizedModal_container__noKSH","text":"unauthorizedModal_text__rtU+Z"};